export const CARD_SHIPMENT_STATUS_ORDER = [
    'IN_PRODUCTION',
    'IN_TRANSIT',
    'DELIVERED',
];
export const CARD_SHIPMENT_STATUS_I18N_KEYS = {
    IN_PRODUCTION: 'benefits.card-tracking.status.created',
    IN_TRANSIT: 'benefits.card-tracking.status.in-transit',
    DELIVERED: 'benefits.card-tracking.status.delivered',
    CANCELED: 'benefits.card-tracking.status.canceled',
};
export function mapCardShipmentStatusToI18nKey(status) {
    return CARD_SHIPMENT_STATUS_I18N_KEYS[status] ?? CARD_SHIPMENT_STATUS_I18N_KEYS.IN_PRODUCTION;
}
export function getCardShipmentStatusIndex(status) {
    const index = CARD_SHIPMENT_STATUS_ORDER.indexOf(status);
    return Math.max(0, index);
}
const CANCELED_ERROR_STEP_INDEX = 1;
export function getCardShipmentStepState(stepIndex, status) {
    if (status === 'CANCELED') {
        if (stepIndex < CANCELED_ERROR_STEP_INDEX) {
            return 'completed';
        }
        if (stepIndex === CANCELED_ERROR_STEP_INDEX) {
            return 'error';
        }
        return 'pending';
    }
    const currentIndex = getCardShipmentStatusIndex(status);
    if (status === 'DELIVERED' || stepIndex < currentIndex) {
        return 'completed';
    }
    if (stepIndex === currentIndex) {
        return 'current';
    }
    return 'pending';
}
